var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "9px",
    viewBox: "0 0 12 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document-Delivery",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Document-Delivery---not-paperless",
    transform: "translate(-665.000000, -720.000000)",
    fill: "#066DA0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M675.855197,721.7572 L675.186997,721.013219 L675.855197,721.7572 Z M676.592247,720.439798 C676.050073,719.879202 675.148431,719.850366 674.566186,720.374414 L668.761127,725.587708 L667.469103,724.344413 C666.906008,723.799772 666.002668,723.799772 665.437733,724.346188 C664.853476,724.908405 664.853476,725.840064 665.439572,726.404055 L667.710291,728.590883 C668.256806,729.125041 669.130354,729.135958 669.700229,728.629332 L676.523064,722.501481 C677.130363,721.956811 677.162385,721.023268 676.592247,720.439798 Z M668.069451,726.208876 L669.431006,726.232322 L668.761127,725.587708 L668.069451,726.208876 Z",
    id: "Path-Copy-3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3229e7a7a1ee92d9b9bdce0719c47ff7.svg";
export { ForwardRef as ReactComponent };